<template>
  <div class="ClaimStep1">
    <div class="loading" id="loading" v-show="loading">
      <div class="circle"></div>
    </div>
    <div class="model">
      <div class="body">
        <p class="title"></p>
        <p class="content"></p>
        <p class="foot"></p>
      </div>
    </div>
    <div class="loading" id="loading" style="display: none;">
      <div class="circle"></div>
    </div>
    <div class="main" style="padding-bottom: 30px;">
      <p class="doc_title" style="margin-bottom:10px;">为了保障您的索赔权益，请确认你符合以下索赔范围并登记（可多选）：</p>
      <p class="doc_text">
        <span class="check" data-index="question1"></span>商户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行销售、购物、转账等操作时，商户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致商户账户资金被盗的；
      </p>
      <p class="doc_text">
        <span class="check" data-index="question2"></span>商户欲前往合法网站进行销售、购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使商户连接上了一个钓鱼网站，导致了商户账户资金被盗的；
      </p>
      <p class="doc_text">
        <span class="check" data-index="question3"></span>商户在合法网站正常操作销售、购物、转账等操作的过程中，钓鱼热点非法获取了商户录入及传递的交易信息，导致商户信息泄露继而造成账户资金被盗；
      </p>
      <p class="doc_text">
        <span class="check" data-index="question4"></span>商户欲下载特定应用软件，商户连接的热点被劫持后，商户实际下载了仿冒恶意软件，且一般商户无法判断该软件的真伪。商户在仿冒恶意软件中录入交易信息，或仿冒软件将劫持的商户短信等个人信息发送至恶意第三方，从而导致商户账户资金遭受损失。
      </p>
      <p class="doc_text">
        <span class="check" data-index="question5"></span>商户连接该热点并用于执行销售、购物、转账等操作的电子设备，被劫持（DNS、ARP）攻击，植入勒索病毒，导致生产中断或者其他直接损失。
      </p>
      <p class="button" style="margin-top:15px;" @click="claimStep1">我要索赔登记</p>
      <p class="doc_a">
        <router-link to="/claimFlow">了解索赔流程</router-link>
      </p>
    </div>
  </div>
</template>

<script>
export default {
  name: 'newclaimStep1',
  mounted() {
    $(".main .doc_text").bind("click", function () {
      $(this).find(".check").toggleClass("checked");
    });
    this.$trace.enterTraceDone({ page: 7, step: 1 });
  },
  data() {
    return {
      appinfo: "",
      loading: false,
    };
  },
  methods: {
    // 获取理赔
    claimStep1 () {
      this.$trace.trace('ins_claim_confirm',  { step: 1, type: 'sup' });
      var params = {};
      var hasSelect = false;
      var traceObj = {};
      $(".main .check").each(function (index, ele) {
        var dataId = $(ele).attr("data-index");
        if ($(ele).hasClass("checked")) {
          params[dataId] = "2";
          traceObj[dataId] = "2";
          hasSelect = true;
        } else {
          params[dataId] = "1";
        }
      });
      this.$trace.trace("ins_claim_btn", {...traceObj, type: 'sup'});
      console.log(`点我要索赔等级`);

      if (!hasSelect) {
        safe.model({
          title: "温馨提示",
          content: "请选择索赔范围",
          foot: "我知道了",
        });
        safe.bindModelEvent();
        return;
      }
      console.log(`点确认登记`, params);
      let array = [params.question1,params.question2,params.question3,params.question4,params.question5]
      this.$router.push(`/new/claimStep2?params=${JSON.stringify(array)}`);
    },
  },
};
</script>

<style scoped>
.main {
  margin-top: 0;
}
.doc_text {
  padding-left: 45px;
  position: relative;
}
.doc_text .check {
  display: block;
  position: absolute;
  left: 24px;
  top: 5px;
  width: 12px;
  height: 12px;
  background-repeat: no-repeat;
  background-position: top center;
  -webkit-background-size: 12px;
  background-size: 12px;
  background-image: url(../images/unselect.png);
}
.doc_text .checked {
  background-image: url(../images/select.png);
}
.doc_text textarea {
  width: 95%;
  margin-top: 2px;
  border: 1px solid #dbdbdb;
  resize: none;
  border-radius: 2px;
  line-height: 18px;
}
.doc_text .inputTips {
  position: absolute;
  font-size: 13px;
  color: #cccccc;
  bottom: 8px;
  right: 10%;
}
</style>



// WEBPACK FOOTER //
// claimStep1.vue?ac3d8208